<template>
  <div>
    <b-card>
      <template #header>
        <div class="d-flex align-items-center">
          <feather-icon
            icon="UserIcon"
            class="mr-2"
            style="font-size: 20px"></feather-icon>
          <h5 class="mb-0">Crear visitante</h5>
        </div>
      </template>

      
      <validation-observer ref="simpleRules">
        <b-form>
          <b-tabs content-class="mt-2" pills>
            <b-tab>
              <template #title>
                <feather-icon icon="FileTextIcon" />
                <span>Detalles visitante </span>
              </template>

              <b-row class="mt-3 justify-content-center">
                <b-button
                  variant="outline-primary"
                  class="mb-1 mb-sm-0 mr-2"
                  :to="{ name: 'visitors' }">
                  <feather-icon
                    icon="ArrowLeftCircleIcon"
                    class="mr-0 mr-sm-50"></feather-icon>
                  Volver Atrás
                </b-button>
              </b-row>
              
              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <validation-provider
                      #default="{ errors }"
                      name="Nombre"
                      rules="required|min:3">
                      <h4>Nombre</h4>
                      <b-form-input
                        id="input-default"
                        size="lg"
                        v-model="body.Nom_titular"
                        required
                        :state="errors.length > 0 ? false : null"
                        autofocus
                        :disabled="disable" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <validation-provider #default="{ errors }" name="Apellido1">
                      <h4>Apellido 1</h4>
                      <b-form-input
                        id="input-default"
                        size="lg"
                        v-model="body.Cognom1_titular"
                        required
                        :state="errors.length > 0 ? false : null"
                        :disabled="disable" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <!-- Apellidos -->
              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Apellido 2</h4>
                    <b-form-input
                      id="input-default"
                      size="lg"
                      v-model="body.Cognom2_titular"
                      :disabled="disable" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>DOI</h4>
                    <b-form-select
                      size="lg"
                      v-model="body.DOI_Type"
                      :options="dniOptions"
                      :disabled="disable" />
                      <validation-provider v-if="body.DOI_Type === 'DNI'" #default="{ errors }" name="DOI" rules="dni" >                      
                      <b-form-input
                        v-if="body.DOI_Type === 'DNI'"
                        id="input-default"
                        size="lg"
                        maxlength="9"
                        v-model="body.DNI"
                        :plaintext="togglePlaintext" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                    <validation-provider
                      v-if="body.DOI_Type === 'Other'"
                      #default="{ errors }"
                      name="DOI"
                      rules="">
                      <b-form-input
                        size="lg"
                        :plaintext="togglePlaintext"
                        v-model="body.DNI" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <!-- DNI y Fecha de nacimiento -->
              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Fecha Nacimiento</h4>
                    <flat-pickr
                      :disabled="disable"
                      v-model="body.Data_neixament"
                      class="form-control" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                   <b-form-group>
                    <h4>Email</h4>
                    <b-form-input
                      id="input-email"
                      v-model="body.email"
                      :disabled="disable" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <!-- Fechas de inicio y fin -->
              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                 <b-form-group>
                    <h4>Teléfono</h4>
                    <b-form-input
                      id="input-telefon"
                      v-model="body.telefon"
                      maxLength="12"
                      :disabled="disable" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <validation-provider #default="{ errors }" name="Empresa_Nom" rules="required">
                    <b-form-group>
                      <h4>Empresa</h4>
                      <div class="d-flex align-items-center">
                        <b-form-select size="lg" v-model="companySeleceted" :options="companies"
                          @change="configureComany()" :disabled="disable" v-if="!body.manualEntry" />
                        <b-form-input v-if="body.manualEntry" v-model="body.manualCompanyName"
                          placeholder="Introduzca el nombre de la empresa" size="lg" class="mt-2" />
                        <b-form-checkbox class="ml-3" v-model="body.manualEntry" :disabled="disable">Manual, no del
                          listado de empresas
                          </b-form-checkbox>
                      </div>
                    </b-form-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>


              <!-- Acreditación -->
              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <validation-provider
                    #default="{ errors }"
                    name="Inicio Acreditación"
                    rules="required">
                    <b-form-group :state="errors.length > 0 ? false : null">
                      <h4>Inicio Acreditación Acceso</h4>
                      <flat-pickr
                        :disabled="disable"
                        v-model="body.datetime_start_acreditation"
                        :state="errors.length > 0 ? false : null"
                        class="form-control"
                        :config="{
                          enableTime: true,
                          defaultDate: body.datetime_start_acreditation,
                          time_24hr: true,
                          locale: {
                            firstDayOfWeek: 1,
                          },
                        }" />
                    </b-form-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                  <validation-provider
                    #default="{ errors }"
                    name="Fin Acreditación"
                    rules="required">
                    <b-form-group :state="errors.length > 0 ? false : null">
                      <h4>Fin Acreditación Acceso</h4>
                      <flat-pickr
                        :disabled="disable"
                        v-model="body.datetime_end_acreditation"
                        :state="errors.length > 0 ? false : null"
                        class="form-control"
                        :config="{
                          enableTime: true,
                          defaultDate: body.datetime_end_acreditation,
                          time_24hr: true,
                          locale: {
                            firstDayOfWeek: 1,
                          },
                        }" />
                    </b-form-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                 <b-form-group>
                    <h4>Horarios</h4>
                    <b-form-select
                      size="lg"
                      v-model="body.pkid_timetable"
                      :options="timetableOptions"
                      :disabled="disable"
                      :select-size="1" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>
                   <b-form-group>
                    <h4>Aforo-Acceso</h4>
                    <b-form-select
                      size="lg"
                      v-model="body.AccesSCA"
                      :options="dooraccesoptions"
                      :disabled="disable" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

                 <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <b-form-group>
                    <h4>Estado documento Acceso</h4>
                    <b-form-select size="lg" v-model="docStatusSelected" :options="docStatusOptions"
                      @change="configureDocStatus()" :disabled="disable" />
                  </b-form-group>
                </b-col>
                <b-col cols="1"></b-col>
                <b-col>

                </b-col>
                <b-col cols="1"></b-col>
              </b-row>


              <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                  <h4>Puertas Permitidas</h4>
                  <b-input-group class="mb-1" style="max-width: 750px;">
                    <b-form-input id="filterInput" v-model="filter2" type="search" placeholder="Buscar..."
                      :disabled="disable" />
                  </b-input-group>
                  <div style="max-height: 200px; overflow-y: auto">
                    <b-table striped hover responsive small :items="items2" :fields="fields2" :filter="filter2">
                      <template #cell(Active)="data">
                        <b-form-checkbox v-model="data.item.tempActive" switch size="lg" :disabled="disable" />
                      </template>
                    </b-table>
                  </div>
                </b-col>
                <b-col cols="1"></b-col>
              </b-row>

              <b-row class="mt-3">
                <h4>Credenciales</h4>
                <b-col class="text-right">
                  <b-button variant="success" @click="addCard" class="mb-1" :disabled="disable">
                    Añadir Credencial
                  </b-button>
                </b-col>
              </b-row>

              <b-table striped hover responsive class="position-relative" :per-page="perPage"
                :current-page="currentPage" :items="items" :fields="fields" :disabled="disable">
                <template #cell(actions)="data">
                  <b-button size="sm" variant="info" @click="openEditModal(data.item)" class="mr-1" :disabled="disable">
                    Editar
                  </b-button>
                </template>

                <template #cell(card_type)="data">
                  <b-badge :variant="activeLabel[1][data.item.card_type]"
                    class="d-inline-flex align-items-center gap-2 p-2 text-dark" :disabled="disable">
                    <img v-if="data.item.card_type === 'mifare'" :src="require('@/assets/images/icons/card.png')"
                      alt="MiFare" title="MiFare" style="height: 30px" />
                    <img v-else-if="data.item.card_type === 'carplate'" :src="require('@/assets/images/icons/car.png')"
                      alt="CarPlate" title="CarPlate" style="height: 30px" />
                    <span>
                      {{ activeLabel[0][data.item.card_type] }}
                    </span>
                  </b-badge>
                </template>

                <template #cell(active)="data">
                  <b-badge :variant="data.value ? 'success' : 'danger'">
                    {{ data.value ? "true" : "false" }}
                  </b-badge>
                </template>
              </b-table>

              <!-- Modal de edición -->
              <b-modal v-model="showEditModal" title="Editar Tarjeta" @ok="saveCard" @hide="resetForm"
                ok-title="Guardar" cancel-title="Cancelar">
                <b-form @submit.prevent="submitForm">
                  <b-form-group label="Número Tarjeta">
                    <b-form-input v-model="selectedCard.card_number" required />
                  </b-form-group>
                  <b-form-group label="Tipo Tarjeta">
                    <b-form-select v-model="selectedCard.card_type" :options="cardTypeOptions" required />
                  </b-form-group>
                  <b-form-group label="Activo">
                    <b-form-checkbox v-model="selectedCard.active">
                      {{ selectedCard.active ? "Sí" : "No" }}
                    </b-form-checkbox>
                  </b-form-group>
                </b-form>
              </b-modal>

              <!-- Modal de edición -->
              <b-modal v-model="showCreateModal" title="Crear Tarjeta" @ok="handleCreateCard" ok-title="Guardar"
                cancel-title="Cancelar">
                <b-form @submit.prevent="handleCreateCard">
                  <b-form-group label="Número Tarjeta" label-for="card-number">
                    <b-form-input id="card-number" v-model="selectedCard.card_number"
                      :state="errors.card_number ? false : null" />
                    <b-form-invalid-feedback v-if="errors.card_number">
                      {{ errors.card_number }}
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group label="Tipo Tarjeta" label-for="card-type">
                    <b-form-select id="card-type" v-model="selectedCard.card_type" :options="cardTypeOptions"
                      :state="errors.card_type ? false : null" />
                    <b-form-invalid-feedback v-if="errors.card_type">
                      {{ errors.card_type }}
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group>
                    <b-form-checkbox v-model="selectedCard.active">Activo</b-form-checkbox>
                  </b-form-group>
                </b-form>
              </b-modal>

              <!-- Botones de acción -->
              <b-row class="mt-3 justify-content-center">
                <b-button
                  v-if="isEditing"
                  variant="primary"
                  class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                  @click.prevent="validationForm"
                  :disabled="disable">
                  <feather-icon
                    icon="SaveIcon"
                    class="mr-0 mr-sm-50"></feather-icon>
                  Crear visitante
                </b-button>
                <b-button
                  variant="outline-primary"
                  class="mb-1 mb-sm-0 mr-2"
                  :to="{ name: 'visitors' }">
                  <feather-icon
                    icon="ArrowLeftCircleIcon"
                    class="mr-0 mr-sm-50"></feather-icon>
                  Volver Atrás
                </b-button>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BCard,
  BCardText,
  BTabs,
  BTab,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BInputGroup,
  BInputGroupPrepend,
  BRow,
  BCol,
  BFormSelect,
  BCardBody,
  BPagination,
  BBadge,
  BFormInvalidFeedback,
  BFormValidFeedback,
  BInputGroupAppend,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import axios from "@/libs/axios";
import { ref } from "@vue/composition-api";
import { extend } from "vee-validate";
import { regex } from "vee-validate/dist/rules";
import { decryptString } from "@/libs/crypto";
import vSelect from "vue-select";
import router from "@/router";
import moment from "moment";

extend("dni", {
  ...regex,
  params: ["lazy"],
  validate: (value) => {
    if (/^(\d{8})([A-Z])$/.test(value)) {
      if (
        "TRWAGMYFPDXBNJZSQVHLCKE".charAt(parseInt(value, 10) % 23) ===
        value.charAt(8)
      ) {
        return true;
      }
      return "La letra del DOI es incorrecta";
    }
    return "El DOI no es válido";
  },
});

export default {
  components: {
    BTable,
    BCard,
    BCardText,
    BTabs,
    BTab,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BInputGroup,
    BInputGroupPrepend,
    BRow,
    BCol,
    BFormSelect,
    BCardBody,
    BPagination,
    BBadge,
    BFormInvalidFeedback,
    BFormValidFeedback,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
    flatPickr,
    vSelect,
  },

  watch: {
    aforoPermitSelected(value) {
      this.body.Aforo_permit = "";
      let first = true;
      value.forEach((element) => {
        const idAforo = element.split(" - ")[1].replace(/[()]/g, "");
        if (first) {
          this.body.Aforo_permit = idAforo;
          first = false;
        } else {
          this.body.Aforo_permit += "," + idAforo;
        }
      });
    },
  },

  methods: {
    async validationForm() {
      try {
        
        const currentUserId = decryptString(localStorage.getItem("idUser")) || "unknown";
        const success = await this.$refs.simpleRules.validate();
if (!success) {
  this.$bvToast.toast("Te faltan campos obligatorios", {
    title: "Atención",
    variant: "warning",
    solid: true,
  });
  return;
}

        if (!this.employeeCreated) {
          const confirmedCreate = await this.$bvModal.msgBoxConfirm(
            "¿Quieres crear un visitante?",
            {
              title: 'Confirmación',
              size: 'md',
              okTitle: 'Sí',
              cancelTitle: 'No',
              footerClass: 'p-2',
              hideHeaderClose: false,
              centered: true
            }
          );
          if (!confirmedCreate) return;

          const [error, pkidOrMessage] = await this.onSubmit();
          if (error) {
            this.$bvToast.toast(String(pkidOrMessage), {
              title: "Error",
              variant: "danger",
              solid: true
            });
            return;
          }
          //console.log(pkidOrMessage)

          this.currentPkid = pkidOrMessage;
          this.employeeCreated = true; // marcamos que ya se creó el empleado
                  // Filtrar puertas que cambiaron
        const doorsToUpdate = this.items2
          .filter(d => d.tempActive !== d.wasActive)
          .map(d => ({
            pkid_door: d.pkid_door,
            Active: d.tempActive ? 1 : 0,
          }));

        if (doorsToUpdate.length > 0) {
          // Enviar userId aparte, junto con las puertas
          await axios.put(`/DoorByPerson/${pkidOrMessage}`, {
            userId: currentUserId,
            doors: doorsToUpdate
          });
        }



          if (this.newCards && this.newCards.length > 0) {
            for (const card of this.newCards) {
              await axios.post('/cards', {
                card_number: card.card_number,
                card_type: card.card_type,
                active: card.active ? 1 : 0,
                fkid_accreditation_document_detail: this.currentPkid,
                user_creation: card.user_creation,
              });
            }
            this.newCards = [];
            this.$bvToast.toast("Tarjetas guardadas correctamente", {
              title: "Éxito",
              variant: "success",
              solid: true,
            });
          }

          this.isEditing = false;
          this.togglePlaintext = true;
          this.disable = true;

          this.$bvToast.toast("Visitante creado correctamente", {
            title: "Éxito",
            variant: "success",
            solid: true
          });

        }

        const confirmedUpdateDevices = await this.$bvModal.msgBoxConfirm(
          "Quieres actualitzar los dispositivos?",
          {
            title: 'Actualizar dispositivos',
            size: 'md',
            okTitle: 'Sí',
            cancelTitle: 'No',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          }
        );
        if (!confirmedUpdateDevices) return;


        const url = process.env.VUE_APP_URL_API_UPDATE_CREDENTIALS;
        await axios.post(url, { id: this.currentPkid });

        this.$bvToast.toast("Post de visitante enviado correctamente", {
          title: "Post enviado",
          variant: "info",
          solid: true,
        });



      } catch (error) {
        console.error("Error en validationForm:", error);
        this.$bvToast.toast(error.response?.data?.error || "Error general", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },

    async fetchVisitors(detailId) {
      try {
        const response = await axios.get("/employees", {
          params: {
            pkid_accreditation_document_detail: detailId,
            fkid_accreditation_process_type: 4
          },
        });
        // response.data es un array de resultados
        if (response.data && response.data.length > 0) {
          const visitorsData = response.data[0];
          // Ahora puedes usar employeeData para rellenar tu formulario o lo que necesites
          this.visitorsData = visitorsData; // Por ejemplo, asignar a una variable reactive
        } else {
        }
      } catch (error) {
        console.error("Error al recuperar visitante:", error);
        this.$toast.error("No se pudieron cargar los datos del visitantes");
      }
    },

    async loadEmployeeCards() {
      try {
        if (!this.currentPkid) {
          throw new Error("No hay ID de visitante disponible");
        }

        const result = await axios.get("/getCardByUsuari", {
          params: {
            pkid_accreditation_document_detail: this.currentPkid,
          },
        });

        this.items = result.data.map((card) => ({
          pkidcard: card.pkidcard,
          Fkid_accreditation_document_detail:
            card.fkid_accreditation_document_detail,
          card_number: card.card_number,
          card_type: card.card_type,
          active: card.active,
          timestamp_modification: card.timestamp_modification,
          user_creation: card.user_creation,
          timestamp_creation: card.timestamp_creation,
        }));
      } catch (error) {
        console.error(
          "Error detallado:",
          error.response?.data || error.message
        );
        this.$bvToast.toast(
          "Error al cargar tarjetas: " +
            (error.response?.data?.message || error.message),
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
      }
    },

    //Funcion para cargar las puertas de entrada
    async loadEmployeeDoors() {
  try {
    if (!this.currentPkid) {
      throw new Error("No hay ID de visitante disponible");
    }

    // 1. Obtener aforos permitidos para el usuario
    const aforosResponse = await axios.get(
      `/userAcces?userId=${this.body.ID_usuari_creacio}`
    );
    const aforosPermitidos = aforosResponse.data.map(
      (item) => item.ID_Aforo
    );

    // 2. Filtrar aforos activos
    const aforoResponse = await axios.get(`/aforo?Active=1`);
    const aforosFiltrados = aforoResponse.data.filter((aforo) =>
      aforosPermitidos.includes(aforo.ID_Aforo)
    );

    // 3. Obtener puertas para todos los aforos en un solo request
    const idsArray = aforosFiltrados.map((aforo) => aforo.ID_Aforo);
    // Suponemos que la API acepta IDs separados por coma
    const doorResponse = await axios.get(`/dooracces`, {
      params: { ID_Aforo: idsArray.join(",") },
    });
    const puertasPermitidas = (doorResponse.data || []).map(
      (d) => d.AccesSCA || ""
    );

    // 4. Procesar códigos de puerta
    const codigosPermitidos = puertasPermitidas
      .filter((p) => p) // filtrar valores vacíos o nulos
      .map((p) => p.split(","))
      .flat();

    // 5. Obtener accesos del empleado
    const accesosResponse = await axios.get(
      `/accred-sca-registry/${this.currentPkid}`
    );
    const data = accesosResponse.data || [];

    // 6. Filtrar puertas permitidas
    this.items2 = data
      .filter((item) => {
        if (!item.AccesSCA) return false;
        const codigosPuerta = item.AccesSCA.split(",");
        return codigosPuerta.some((codigo) =>
          codigosPermitidos.includes(codigo)
        );
      })
      .map((item) => ({
        ...item,
        tempActive: item.Active === 1,
      }));

    if (this.items2.length === 0) {
      console.warn("No se encontraron puertas asociadas.");
    }
  } catch (error) {
    this.$bvToast.toast("Error al cargar puertas: " + error.message, {
      title: "Error",
      variant: "danger",
      solid: true,
    });
  }
},


    configureComany() {
      const company = this.companySeleceted.split(" - ");
      const idCompany = company[1].replace(/[()]/g, "");
      this.body.fkid_accreditation_company = idCompany;
      this.body.Empresa_nom = company[0];
    },

    configureAforoMain() {
      const aforo = this.aforoMainSelected.split(" - ");
      const idAforo = aforo[1].replace(/[()]/g, "");
      this.body.Aforo_main = idAforo;
    },

    configureDocStatus() {
      if (!this.docStatusSelected) return;
      const docStatus = this.docStatusSelected.split(" - ");
      this.body.fkid_accreditation_status = docStatus[0];
      this.body.DocStatus = docStatus[1];
    },


    async message() {
      const error = await this.onSubmit();
      if (error[0]) {
        const variant = "danger";
        this.$bvToast.toast("" + error[1], {
          title: "Error",
          variant,
          solid: true,
        });
      } else if (!error[0]) {
        this.togglePlaintext = true;
        this.date = true;
        this.hiddenComponent = true;
        const variant = "success";
        this.$bvToast.toast("Visitante creado correctamente", {
          title: "Update",
          variant,
          solid: true,
        });
      }
    },
    openEditModal(card) {
      this.selectedCard = {
        ...card,
        active: card.active === 1 || card.active === true,
      };
      this.showEditModal = true;
    },

    async saveCard() {
      try {
        if (!this.selectedCard || !this.selectedCard.pkidcard) {
          throw new Error(
            "No se ha seleccionado una tarjeta válida para editar"
          );
        }

        const response = await axios.put(
          `/cards/${this.selectedCard.pkidcard}`,
          {
            pkid_accreditation_document_detail:
              this.selectedCard.fkid_accreditation_document_detail,
            card_number: this.selectedCard.card_number,
            card_type: this.selectedCard.card_type,
            active: this.selectedCard.active,
            user_creation: decryptString(localStorage.getItem("idUser")),
          }
        );

        // Actualizar la tabla
        const index = this.items.findIndex(
          (item) => item.pkidcard === this.selectedCard.pkidcard
        );
        if (index !== -1) {
          this.items.splice(index, 1, { ...this.selectedCard });
        }

        this.$bvToast.toast("Tarjeta actualizada correctamente", {
          title: "Éxito",
          variant: "success",
          solid: true,
        });
        this.showEditModal = false;
        await this.loadCards();
      } catch (error) {
        console.error("Error al actualizar la tarjeta:", error);
        this.$bvToast.toast(error.message, {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },

    async addCard() {
      try {
        if (!this.currentPkid) {
          throw new Error("No se ha obtenido el ID del visitante");
        }

        this.selectedCard = {
          pkidcard: null,
          card_number: "",
          card_type: "",
          active: true,
          user_creation: "",
          fkid_accreditation_document_detail: this.currentPkid,
        };

        this.showCreateModal = true;
      } catch (error) {
        console.error("Error al intentar agregar tarjeta:", error);
        this.$bvToast.toast(error.message, {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },

    async handleCreateCard(bvModalEvt) {
      try {
        bvModalEvt.preventDefault();

        if (!this.selectedCard.card_number || !this.selectedCard.card_type) {
          throw new Error("Por favor complete todos los campos requeridos");
        }

        if (!this.currentPkid) {
          throw new Error("No se ha obtenido el ID del visitante");
        }

        const response = await axios.post("/cards", {
          pkidcard: this.selectedCard.pkidcard,
          card_number: this.selectedCard.card_number,
          card_type: this.selectedCard.card_type,
          active: this.selectedCard.active,
          fkid_accreditation_document_detail: this.currentPkid,
          user_creation: decryptString(localStorage.getItem("idUser")),
        });

        await this.loadCards();

        this.$bvToast.toast("Tarjeta creada correctamente", {
          title: "Éxito",
          variant: "success",
          solid: true,
        });

        this.showCreateModal = false;
        this.resetForm();
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          this.$bvToast.toast(error.response.data.error, {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        } else {
          this.$bvToast.toast(
            "Error al intentar crear la tarjeta. Inténtalo de nuevo.",
            {
              title: "Error",
              variant: "danger",
              solid: true,
            }
          );
        }
      }
    },

    resetForm() {
      this.selectedCard = {
        pkidcard: null,
        card_number: "",
        card_type: "",
        active: false,
        user_creation: "",
      };
    },

    async loadCards() {
      const pkid_accreditation_document_detail = this.currentPkid;
      try {
        const result = await axios.get("/getCardByUsuari", {
          params: { pkid_accreditation_document_detail },
        });
        this.items = result.data.map((card) => ({
          pkidcard: card.pkidcard,
          Fkid_accreditation_document_detail:
            card.fkid_accreditation_document_detail,
          card_number: card.card_number,
          card_type: card.card_type,
          active: card.active,
          timestamp_modification: card.timestamp_modification,
          user_creation: card.user_creation,
          timestamp_creation: card.timestamp_creation,
        }));
      } catch (error) {
        console.error("Error al cargar las tarjetas:", error);
      }
    },

    async onToggleActive(item) {
      // Simplemente invierte el valor local
      item.tempActive = !item.tempActive;
    },
  },

  computed: {
    dooraccesoptions() {
      return this.dooracces.map((acc) => ({ text: acc, value: acc }));
    },
    docStatusOptions() {
      return this.docStatus;
    },
    statusVariant() {
      const statusColor = {
        OK: "light-success",
        OK_Exit: "light-warning",
        "OK_Exit+": "light-warning",
        OK_entered: "light-info",
        ERROR: "light-danger",
        "INCORRECTO No es válido realizar movimiento de salida": "light-danger",
        REPETIT: "light-danger",
        "Fecha de vencimiento fuera de plazo": "light-danger",
        "Fecha de fin de validez fuera de plazo": "light-danger",
        "Fecha de caducidad fuera de plazo": "light-danger",
        "No existe documento en detalle de evento": "light-danger",
        "DE BAJA Entrada dada de baja": "light-danger",
        "ERROR DNI ACREDITACIÓN duplicado": "light-danger",
        "ACREDITACIÓN anulada": "light-danger",
        "DENEGADA ACREDITACIÓN": "light-danger",
      };
      return (status) => statusColor[status];
    },
  },

  data() {
    return {
      required,
      disable: false,
      hiddenComponent: false,
      togglePlaintext: false,
      dniOptions: [
        { text: "DNI", value: "DNI" },
        { text: "Otro", value: "Other" },
      ],
      companySeleceted: ",",
      companies: [],
      perPage: 10,
      pageOptions: [5, 10, 20, 50],
      totalRows: 1,
      currentPage: 1,
      items: [],
      items1: [],
      items2: [],
      filter2: "",
      aforoMainSelected: "",
      dooracces: [],
      timetables: [],
      timetableOptions: [],
      matriculasInput: "",
      Matricula: [],
      aforos: [],
      docStatusSelected: "",
      docStatus: [],
      aforoPermitSelected: [],
      isEditing: true,
      errors: {
        card_number: '',
        card_type: '',
      },
      fields: [
        { key: "pkidcard", label: "ID" },
        { key: "card_number", label: "Número targeta" },
        { key: "card_type", label: "Tipo" },
        { key: "active", label: "Activo", formatter: (value) => !!value },
        {
          key: "timestamp_modification",
          label: "Fecha Modificación",
          formatter: (value) => {
            return value ? moment(value).utc().format("DD/MM/YYYY HH:mm") : "";
          },
        },
        { key: "user_creation", label: "Creación Usuario" },
        {
          key: "timestamp_creation",
          label: "Fecha Creación",
          formatter: (value) => {
            return value ? moment(value).utc().format("DD/MM/YYYY HH:mm") : "";
          },
        },
        { key: "actions", label: "Acciones" },
      ],
      fields2: [
        { key: "Active", label: "Estado" },
        { key: "Aforo_name", label: "Aforo" },
        { key: "Name", label: "Nombre Puerta" },
      ],
      showEditModal: false,
      showDeleteModal: false,
      showCreateModal: false,
      selectedCard: {
        pkidcard: null,
        fkid_accreditation_document_detail: null,
        card_number: "",
        card_type: "",
        active: false,
        user_creation: "",
      },
      refreshInterval: null,
      pollInterval: 5000,
      cardTypeOptions: [
        { text: "Mifare", value: "mifare" },
        { text: "CarPlate", value: "carplate" },
      ],
      filters: {
        startDateFilter: moment().subtract(7, "days").format("YYYY-MM-DD"),
        endDateFilter: moment().format("YYYY-MM-DD"),
      },
      activeLabel: [
        {
          mifare: "-MiFare",
          carplate: "-CarPlate",
        },
        {
          mifare: "default",
          carplate: "default",
        },
      ],
      filtersConfig: [
        {
          key: "startDateFilter",
          label: "Rango Fechas",
          type: "date-range",
          param: "datetime_start_acreditation",
          formatter: (value) =>
            value ? moment(value).format("YYYY-MM-DD") : null,
        },
      ],
      visitors: null,
    };
  },

  async created() {

    //cargar los status
    await axios
      .get("/docStatus")
      .then((results) => {
        results.data.forEach(element => {
          this.docStatus.push(element.pkid_accreditation_status + " - " + element.Description)
        });
        this.docStatusSelected =
          this.docStatus = this.docStatus.map((t) => ({ text: t, value: t }));
        this.docStatusSelected = this.docStatus[0].text
        const docStatus = this.docStatusSelected.split(" - ");
        this.body.fkid_accreditation_status = docStatus[0]
        this.body.DocStatus = docStatus[1];
      })
      .catch((error) => {
        const variant = "danger";
        this.$bvToast.toast("Fallo al conectar", {
          title: `` + error,
          variant,
          solid: true,
        });
      })


    // Cargar compañías
    await axios
      .get("/company")
      .then((results) => {
        results.data.forEach((element) => {
          this.companies.push(
            element.Name + " - (" + element.pkid_accreditation_company + ")"
          );
        });
      })
      .catch((error) => {
        this.$bvToast.toast("Fallo al conectar", {
          title: "" + error,
          variant: "danger",
          solid: true,
        });
      });

    
      try {
  // Paso 1: obtener aforos permitidos para el usuario
  const aforosPermitidosResp = await axios.get(
    `/userAcces?userId=${this.body.ID_usuari_creacio}`
  );
  const aforosPermitidos = aforosPermitidosResp.data.map(
    (item) => item.ID_Aforo
  );

  // Paso 2: obtener todos los aforos activos y filtrarlos por los permitidos
  const aforosResp = await axios.get(`/aforo?Active=1`);
  const aforosFiltrados = aforosResp.data.filter((element) =>
    aforosPermitidos.includes(element.ID_Aforo)
  );

  this.aforos = aforosFiltrados.map(
    (element) => `${element.Aforo_name} - (${element.ID_Aforo})`
  );

  // Paso 3: enviar un solo request con el array de IDs de aforo
  const idsArray = aforosFiltrados.map(aforo => aforo.ID_Aforo);

  // Suponemos que la API acepta los IDs como parámetro query separados por coma
  const doorResp = await axios.get(`/dooracces`, {
    params: { ID_Aforo: idsArray.join(',') }
  });

  // Devolvemos todos los accesos planos
  this.dooracces = doorResp.data.map(d => d.AccesSCA);

} catch (error) {
  this.$bvToast.toast("Error al obtener aforos o puertas", {
    title: "" + error,
    variant: "danger",
    solid: true,
  });
}

    // Cargar timetables
    axios
      .get("/timetable")
      .then((response) => {
        this.timetableOptions = [
          { value: null, text: "" },
          ...response.data.map((timetable) => ({
            value: timetable.pkid_timetable,
            text: `${timetable.name} - ${timetable.description}`,
          })),
        ];
      })
      .catch((error) => {
        this.$bvToast.toast("Error al cargar los horarios", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      });
  },

  mounted() {
    if (localStorage.getItem("accessToken") === null) {
      this.$router.go(0);
    }
    const detailId = this.$route.query.id;
    if (detailId) {
      this.currentPkid = detailId;
      this.fetchVisitors(detailId); // esta función debe cargar employee y también setear body.ID_usuari_creacio
      this.loadEmployeeCards();
      this.loadEmployeeDoors();
    } else {
      this.$toast.warning("No se proporcionó ID de empleado");
    }
  },

  setup() {
    const userId = decryptString(localStorage.getItem("idUser")) || "unknown";
    const currentPkid = ref(null);

    const blankPersonData = {
      pkid_accreditation_document_detail: undefined,
      fkid_accreditation_document: 0,
      fkid_accreditation_process_type: 4,
      fkid_accreditation_status: "000000",
      fkid_accreditation_status_sca: "",
      fkid_mxs_event: "",
      Temporada: "",
      ID_Aforo: "",
      ID_Event: "",
      fkid_persona: "",
      Nom_titular: "",
      Cognom1_titular: "",
      Cognom2_titular: "",
      DOI_Type: "",
      Cod_Barras: "",
      AccesSCA: "",
      DNI: "",
      Data_neixament: "",
      datetime_start_acreditation: moment().format('YYYY-MM-DD HH:mm'),
      datetime_end_acreditation: moment().add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm'),
      email: "",
      pkid_timetable: null,
      ID_usuari_creacio: userId,
    };

    const body = ref(JSON.parse(JSON.stringify(blankPersonData)));

    const onSubmit = async () => {
      try {
        // Asegúrate de asignar un valor válido para pkid_accreditation_document_detail
        if (currentPkid.value) {
          body.value.pkid_accreditation_document_detail = currentPkid.value;
        } else {
          throw new Error("currentPkid no está definido");
        }

        body.value.ID_usuari_modificacio = userId;

        await axios.put("/employeesDNI", body.value);

        // Aquí usa pkid_timetable y no timetables
        await axios.post("/insertTimetable", {
          fkid_accreditation_document_detail:
            body.value.pkid_accreditation_document_detail,
          fkid_timetable: body.value.pkid_timetable,
        });

        return [false, currentPkid.value];
      } catch (error) {
        console.error("Error al actualizar visitor:", error);
        if (error.response && error.response.status === 409) {
          // Error de duplicado desde backend
          return [true, error.response.data.Error];
        }

        // Otros errores
        return [true, "Error inesperado al actualizar visitor"];
      }
    };

    return {
      body,
      onSubmit,
      currentPkid,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
